module.exports = __webpack_public_path__ + "img/9791187038030.23b3ec98.jpg";